export default __webpack_public_path__ + "static/media/hero.0acd27ec.png";